<template>
    <b-overlay :show="is_load">
        <div class="categ_info" v-if="location.id > 0">
            <fileload
                @on_load="on_loading_files"
                :doc_id="location.id"
                doc_type="pwa_rest"
            ></fileload>
        </div>
    </b-overlay>
</template>

<script>
import Fileload from "../../../../sys/file_loader/fileload";
export default {
    name: "pwa_location_image",
    props : {
        location : {
            type : Object
        }
    },
    components: {
        Fileload
    },

    data() {
        return {
            is_loaded : false,
            is_load: false,
            my_files : []
        }
    },
    created() {

    },

    methods: {
        on_loading_files(state) {
            this.is_load = state;
        }
    },
}
</script>

<style scoped>

</style>
